import {InputTitleNormal, SectionTitle} from '../../AdminPanel/common/TitleStyle'
import styled from '@emotion/styled'
import {Button, IconButton, Box} from '@mui/material'
import {FILTERS_DRAWER_WIDTH} from '../../components/FilterPanel/FilterPanelStyle'

const DescriptionTitle = styled(SectionTitle)(() => ({
  marginBottom: '16px',
  marginLeft: '-65px'
}))

const NameTitleNormal = styled('div')(({theme}) => ({
  fontFamily: 'Open Sans',
  fontStyle: 'normal',
  fontWeight: theme.typography.fontWeightRegular,
  fontSize: theme.typography.subtitle1.fontSize,
  lineHeight: '19px',
  letterSpacing: '0.210459px',
  marginLeft: '4px',
  color: theme.palette.hpAccentBlack
}))

const TitleEdit = styled('div')(({theme}) => ({
  fontFamily: 'Open Sans',
  fontStyle: 'normal',
  fontWeight: theme.typography.fontWeightRegular,
  fontSize: theme.typography.subtitle1.fontSize,
  lineHeight: '19px',
  letterSpacing: '0.210459px',
  marginLeft: '4px',
  color: theme.palette.hpBlack,
  marginTop: '10px'
}))

const InputError = styled(InputTitleNormal)(({theme}) => ({
  color: theme.palette.hpAccentRed,
  fontSize: theme.typography.subtitle2.fontSize,
  width: '320px',
  marginLeft: '4px'
}))

const TryButton = styled(Button)(() => ({
  textTransform: 'capitalize'
}))

const EditClientButton = styled(IconButton)(({theme}) => ({
  marginLeft: '8px',
  display: 'inline-block',
  width: '32px',
  height: '32px',
  marginTop: '10px',
  padding: '0px',
  '&:hover': {
    backgroundColor: theme.palette.hpPrimaryLightest
  }
}))

const StyledDiv = styled('div')(() => ({
  display: 'flex',
  padding: '5px 6px 0px 2px'
}))

const MainBoxClient = styled(Box)(() => ({
  display: 'flex',
  flexFlow: 'column',
  maxWidth: 'calc(100vw - 64px)',
  marginTop: 0
}))

// MainBoxClient variant for standalone pages (not nested inside AdminPanel's MainBox)
const MainBoxClientLanding = styled(MainBoxClient)(({theme}) => ({
  marginLeft: `-${FILTERS_DRAWER_WIDTH}px`,
  padding: theme.spacing(2),
  marginTop: theme.spacing(5)
}))

export {
  DescriptionTitle,
  NameTitleNormal,
  InputError,
  TryButton,
  EditClientButton,
  StyledDiv,
  TitleEdit,
  MainBoxClient,
  MainBoxClientLanding
}
